import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { getLanguage, getLanguageFromUrl, Language } from 'src/app/language';
import { Acabado, Maestros, Material, Stock, UnidadMedida, Disponibilidad } from 'src/app/models';
import { MaterialesService } from 'src/app/services';
import { ModuleState } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mosaic-detail',
  templateUrl: './mosaic-detail.component.html',
  styleUrls: ['./mosaic-detail.component.css']
})
export class MosaicDetailComponent implements OnInit {

  @Input('stock') stock: Stock[] = [];
  @Input('maestros') maestros: Maestros;
  @Input('language') language: Language;
  @Input('unidadMedida') unidadMedida: UnidadMedida;
  @Input('hasSimilar') hasSimilar: boolean = false;
  @Output('onSelectStock') onSelectStock: EventEmitter<Stock> = new EventEmitter<Stock>();
  @Output('onScrolled') onScrolled: EventEmitter<void> = new EventEmitter<void>();

  loadingMaestros: boolean = false;
  loadingStock: boolean = false;
  loadingMaterialesSimilares: boolean = false;
  groupByBundle: boolean = false;

  constructor(private materialesService: MaterialesService, private store: Store) { }

  getNombreMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getNombreMaterial(codigo, this.maestros);
  }

  getNombreTipoMaterial(id: Material['TIPOMATERIALID']): string {
    return this.materialesService.getNombreTipoMaterial(id, this.maestros);
  }

  getAcabadoMaterial(codigo: Acabado['CODIGO']): string {
    return this.materialesService.getAcabadoMaterial(codigo, this.maestros);
  }

  getAncho(val: string): string {
    return this.materialesService.getAncho(val)
  }

  getDisponibilidad(codigo: Disponibilidad['CODIGO']): string {
    return this.materialesService.getDiponibilidad(codigo, this.maestros);
  }

  getColorMaterial(codigo: Material['CODIGO']): string {
    return this.materialesService.getColorMaterial(codigo, this.maestros);
  }

  selectStock(item: Stock): void {
    return this.onSelectStock.emit(item);
  }

  getMedida(medida: string): string {
    return parseFloat(medida) + 'CM'
  }

  getRangoAltura(item: Stock): string {
    return this.materialesService.getRangoMedidaAlto(item, this.unidadMedida);
  }

  getRangoAnchura(item: Stock): string {
    return this.materialesService.getRangoMedidaAncho(item, this.unidadMedida);
  }

  getMedidaAncho(item: Stock): string {
    return this.materialesService.getMedidaAncho(item, this.unidadMedida);
  }

  getMedidaAlto(item: Stock): string {
    return this.materialesService.getMedidaAlto(item, this.unidadMedida);
  }

  getPiezas(piezas: string) {
    return parseFloat(piezas);
  }

  getUnidadLanguage(): string {
    return this.unidadMedida === UnidadMedida.CM ? 'cm' : getLanguage(getLanguageFromUrl()).PULGADAS
  }

  ngOnInit(): void {
    this.groupByBundle = environment.byBundle;

    this.store.select((state: ModuleState) => state.ui).subscribe(ui => {
      this.loadingMaestros = ui.loadingMaestros;
      this.loadingMaterialesSimilares = ui.loadingMaterialesSimilares;
      this.loadingStock = ui.loadingStock;      
    })
  }

}
